import { t } from '@ankr.com/common';
import { GroupUserRole } from 'multirpc-sdk';

import { teamRoleNamesMap } from '../constants';

export const getTeamRoleName = (role: GroupUserRole) =>
  t(teamRoleNamesMap[role] || 'teams.roles.owner');
